import Big from "big.js";
import moment from "moment";
moment.locale("en");
import Locale from "./Locale";
var JSEncrypt = {};
if(typeof window != "undefined")
{
    JSEncrypt = require("jsencrypt").JSEncrypt;
}
moment.prototype.formatMs = function (str) {
    return this.format(str || "YYYY-MM-DD HH:mm:ss");
};
Big.RM = 0;
Big.prototype.toFixedMax = function (max) {
  //限定小数最多保留 max 位
  return Big(this.toFixed(max)).toFixed();
};
Big.prototype.toFixedMin = function (min) {
  //限定小数最少保留 min 位
  const str = this.toFixed();
  const strMin = this.toFixed(min);
  return strMin.length > str.length ? strMin : str;
};
Big.prototype.toFixedCy = function (dp, rm) {
  try {
    const str = this.toFixed(dp, rm);
    const ary = str.split(".");
    const retAry = [ary[0].replace(/\d(?=(\d{3})+$)/g, "$&,")];
    ary[1] && retAry.push(ary[1]);
    return retAry.join(".");
  } catch (e) {
    console.error(e);
    return this.toFixed(dp, rm);
  }
};
Big.prototype.toFixedMaxCy = function (max) {
  try {
    const str = this.toFixedMax(max);
    const ary = str.split(".");
    const retAry = [ary[0].replace(/\d(?=(\d{3})+$)/g, "$&,")];
    ary[1] && retAry.push(ary[1]);
    return retAry.join(".");
  } catch (e) {
    console.error(e);
    return this.toFixedMaxCy(max);
  }
};
Big.prototype.toFixedMinCy = function (min) {
  try {
    const str = this.toFixedMin(min);
    const ary = str.split(".");
    const retAry = [ary[0].replace(/\d(?=(\d{3})+$)/g, "$&,")];
    ary[1] && retAry.push(ary[1]);
    return retAry.join(".");
  } catch (e) {
    console.error(e);
    return this.toFixedMinCy(min);
  }
};

const Util = {
    /*
    options:{
        noProtocol : Boolean
        ws : Boolean
    }
    */
    getHost:()=>{
        if(process.env.NEXT_PUBLIC_host && process.env.NEXT_PUBLIC_protocol)
        {
            return {
                protocol:process.env.NEXT_PUBLIC_protocol,
                domain:process.env.NEXT_PUBLIC_host
            }
        }
        const env = JSON.parse(JSON.stringify(process.env)).NODE_ENV;
        if (env == "development") {
            return {
                protocol:"http:",
                domain:"www.sigma115.com"
            };
        }
        else if (env == "test") {
            return {
                protocol:"https:",
                domain:"www.spikex.com"

            };
        }
        else if (env == "qa") {
            return {
                protocol:"https:",
                domain:"www.uxmex.com"

            };
        }
        else if (env == "uat") {
            return {
                protocol:"https:",
                domain:"www.spikex.com"
            };
        }
        return {
            protocol:"https:",
            domain:"www.spikex.com"
        };
    },
    getOrigin : (name, options) => {
        var protocol = "https:";
        var domain = "www.spikex.com";
        var localPort = 0;
        if (typeof window != "undefined") {
            var isLocal = window.location.hostname === "localhost" || /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)(\.(?!$)|$)){4}$/.test(window.location.hostname);
            if (options && options.seo && !isLocal) {
                var seoHost = Util.getHost();
                protocol = seoHost.protocol;
                domain = seoHost.domain;
            }
            else if(options && options.ws)
            {
                var host = Util.getHost();
                protocol = host.protocol;
                domain = host.domain;
            }
            else
            {
                protocol = window.location.protocol;
                domain = window.location.host;
                if (isLocal)
                {
                    localPort = location.port;
                }
            }
        }
        else if(typeof(process.env) == "object")
        {
            var isLocal = JSON.parse(JSON.stringify(process.env)).LOCALPORT;
            if(isLocal)
            {
                localPort = isLocal;
            }
            else
            {
                var host = Util.getHost();
                protocol = host.protocol;
                domain = host.domain;
            }
        }
        var retHost = domain;
        if(localPort)
        {
            retHost = localPort == 80 ? "localhost" : "localhost:"+localPort;
        }
        else
        {
            if(name)
              retHost = `${name}.` + domain.split(":")[0]?.split(".").slice(-2).join(".");
        }
        if(options?.noProtocol)
            return retHost;
        if(options?.ws)
            protocol = protocol?.includes("https") ? "wss:" : "ws:";
        return `${protocol}//${retHost}`;
    },
    intlRoutes:{
        "www":["/",
            "/referral",
            "/affiliate",
            "/activity-registration",
            "/rate",
            "/finance/simple-earn",
            "/finance/savings",
            "/finance/staking",
            "/finance/cloud-mining",
            "/listing",
            "/notification",
            "/market",
            "/verify",
            "/app",
            "/more",
            "/search",
            "/aicopy",
            "/aiselect",
        ]
    },
    intlRoutesPrefix:{
        "www":[
            "/affiliate/",
            "/activity",
            "/accounts",
            "/academy",
            "/trade",
            "/futures",
            "/aicopy",
            "/aiselect",
            "/launchpad",
            "/price",
            "/convert",
            // /market 有子页（如 /market/edit-favorites），需要与 /en/ 等语言前缀配合
            "/market/",
            "/credit"
        ]
    },
    /** 与 next.config i18n.locales 一致，用于从 asPath 中剥掉首段语言 */
    nextI18nLocales: ["default", "en", "zh-CN", "pt", "ar", "vi"],
    /** 仅 pathname（无 query），去掉 /en/、/zh-CN/ 等前缀供路由判断 */
    stripNextI18nPathForMatch: (path) => {
        const raw = (path || "").split("?")[0] || "";
        if (!raw || raw === "/") return "/";
        const parts = raw.split("/").filter(Boolean);
        if (parts.length && Util.nextI18nLocales.includes(parts[0])) {
            const rest = parts.slice(1);
            return rest.length ? "/" + rest.join("/") : "/";
        }
        return raw.startsWith("/") ? raw : "/" + raw;
    },
    /** pathname + query 一起剥掉首段语言（给 getUrl 生成给 Vue 的 href） */
    stripNextI18nSegmentFromPath: (path) => {
        const full = path || "";
        const qIdx = full.indexOf("?");
        const raw = qIdx >= 0 ? full.slice(0, qIdx) : full;
        const query = qIdx >= 0 ? full.slice(qIdx) : "";
        return Util.stripNextI18nPathForMatch(raw) + query;
    },
    /** Vue web-index 托管路径：链接不应带 Next i18n 的 /{locale} 前缀。/accounts/* 属 ssr-web-user-center，须拼语言，不在此列 */
    webIndexSpaPathNoIntlLocale: (path) => {
        const test = Util.stripNextI18nPathForMatch(path);
        return (
            test.startsWith("/wallet") ||
            (test.startsWith("/account") && !test.startsWith("/accounts")) ||
            test.startsWith("/orders") ||
            test.startsWith("/user") ||
            test.startsWith("/bills")
        );
    },
    getXTUrl:(path,subDomain)=>{
        if(!subDomain)
          subDomain = "www";
        const host = Util.getHost();
        var {protocol,domain} = host;
        if(subDomain != "www")
          domain = subDomain+"."+domain.split(":")[0]?.split(".").slice(-2).join(".");
        if (Util.webIndexSpaPathNoIntlLocale(path)) {
            const pathPart = path === "/" ? "" : Util.stripNextI18nSegmentFromPath(path);
            return protocol + "//" + domain + (pathPart === "/" ? "" : pathPart);
        }
        const test = path.split('?')[0] || "";
        if(Util.intlRoutes[subDomain] && Util.intlRoutes[subDomain].includes(test))
        {
            path = "/"+Locale.intl.locale+(path=="/" ? "":path);
        }
        else if(Util.intlRoutesPrefix[subDomain])
        {
            for(let key in Util.intlRoutesPrefix[subDomain])
            {
                if(test.startsWith(Util.intlRoutesPrefix[subDomain][key]))
                {
                    path = "/"+Locale.intl.locale+(path=="/" ? "":path);
                    break;
                }
            }
        }
        return protocol+"//"+domain+(path=="/" ? "":path);
    },
    getUrl:(path,domain)=>{
        if(!domain)
          domain = "www";
        if (Util.webIndexSpaPathNoIntlLocale(path)) {
            const pathPart = path === "/" ? "" : Util.stripNextI18nSegmentFromPath(path);
            return Util.getOrigin(domain) + (pathPart === "/" ? "" : pathPart);
        }
        const test = path.split('?')[0] || "";
        if(Util.intlRoutes[domain] && Util.intlRoutes[domain].includes(test))
        {
            path = "/"+Locale.intl.locale+(path=="/" ? "":path);
        }
        else if(Util.intlRoutesPrefix[domain])
        {
            for(let key in Util.intlRoutesPrefix[domain])
            {
                if(test.startsWith(Util.intlRoutesPrefix[domain][key]))
                {
                    path = "/"+Locale.intl.locale+(path=="/" ? "":path);
                    break;
                }
            }
        }
        return Util.getOrigin(domain)+(path=="/" ? "":path);
    },
    debounce : (func, delay) => {
        let timer = null;
        if (!delay) delay = 300;
        return function (...args) {
            if(timer)
                clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    },
    throttle : (func, time) => {
        let timer = null;
        if (!time) time = 500;
        return function (...args) {
            if(timer)
                return;
            timer = setTimeout(() => {
                timer = null;
            }, time);
            func.apply(this, args);
        };
    },
    getDeployEnv : ()=> {
        if(typeof process == "undefined")
            return "production";
        const deployEnv = process.env?.node_deployEnv;
        if(deployEnv == "dev" || deployEnv == "development")
            return "development";
        else if(deployEnv == "test")
            return "test";
        else if(deployEnv == "prod" || deployEnv == "production")
            return "production";
        return "production";
    },
    Big:Big,
    moment:moment,
    showRate:(val)=>{
        if (!+val) return "0.00%";
            return (+val > 0 ? "+" : "") + Big(val).toFixed(2) + "%";
    },
    regexp : (type, content, retRegExp) => {
        const verify = {
          email: /^([a-zA-Z0-9_\.-])+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/,
          // allNumber: /^[0-9]*$/, //废弃
          likePhone: /^[0-9]{5,11}$/, //7位数字显示国家代码
          dynamicCode: /^[0-9]{6}$/, //6位动态验证码
          recommendCode: /^[A-Z0-9a-z]{6,10}$/, //邀请码
          loginPassword: /^(?=.*[A-Z])(?=.*[\d])[A-Za-z\d!@#\$%\^&\*\(\)]{8,1000}$/, //新的登录密码
          securityPassword: /^(?![\d]+$)(?![a-zA-Z]+$)(?![!@#\$%\^&\*\(\)]+$)[\da-zA-Z!@#\$%\^&\*\(\)]{6,20}$/, //新的安全密码
        };
        if (!verify[type]) return;
        if (retRegExp) return verify[type];
        return verify[type].test(content);
    },
    getQuery : (name) => {
        if(typeof window == "undefined")
            return "";
        const url = location.href;
        const str = url.slice(url.indexOf('?') + 1);
        const arr = str.split('&');
        const result = {};
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i].split('=');
          result[item[0]] = item[1];
        }
        return result[name];
    },
    getUUID:()=>{
        let d = new Date().getTime();
        let uuid = "xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        });
        return uuid;
    },
    doRsaEncrypt:(key, value) => {
        if (!key || !value) return value;
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(key);
        const encrypted = encrypt.encrypt(value);
        return encrypted;
    },
    getExplore:()=>{
        if(typeof window == "undefined")
            return "Server";
        var Sys = {};
        var ua = navigator.userAgent.toLowerCase();
        var s;
        (s = ua.match(/rv:([\d.]+)\) like gecko/))
            ? (Sys.ie = s[1])
            : (s = ua.match(/msie ([\d\.]+)/))
                ? (Sys.ie = s[1])
                : (s = ua.match(/edge\/([\d\.]+)/))
                    ? (Sys.edge = s[1])
                    : (s = ua.match(/firefox\/([\d\.]+)/))
                        ? (Sys.firefox = s[1])
                        : (s = ua.match(/(?:opera|opr).([\d\.]+)/))
                            ? (Sys.opera = s[1])
                            : (s = ua.match(/chrome\/([\d\.]+)/))
                                ? (Sys.chrome = s[1])
                                : (s = ua.match(/version\/([\d\.]+).*safari/))
                                    ? (Sys.safari = s[1])
                                    : 0;
        // 根据关系进行判断
        if (Sys.ie) return "IE V" + Sys.ie;
        if (Sys.edge) return "EDGE V" + Sys.edge;
        if (Sys.firefox) return "Firefox V" + Sys.firefox;
        if (Sys.chrome) return "Chrome V" + Sys.chrome;
        if (Sys.opera) return "Opera V" + Sys.opera;
        if (Sys.safari) return "Safari V" + Sys.safari;
        return "Unknown";
    },
    getPlatform:()=>{
        if(typeof window == "undefined")
            return "Server";
        var sUserAgent = navigator.userAgent;
        var isWin = navigator.platform == "Win32" || navigator.platform == "Windows";
        var isMac = navigator.platform == "Mac68K" || navigator.platform == "MacPPC" || navigator.platform == "Macintosh" || navigator.platform == "MacIntel";
        if (isMac) return "Mac OS";
        var isUnix = navigator.platform == "X11" && !isWin && !isMac;
        if (isUnix) return "Unix";
        var isLinux = String(navigator.platform).indexOf("Linux") > -1;
        if (isLinux) return "Linux";
        if (isWin) {
            var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
            if (isWin2K) return "Win2000";
            var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
            if (isWinXP) return "WinXP";
            var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
            if (isWin2003) return "Win2003";
            var isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
            if (isWinVista) return "WinVista";
            var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
            if (isWin7) return "Win7";
            var isWin10 = sUserAgent.indexOf("Windows NT 10") > -1 || sUserAgent.indexOf("Windows 10") > -1;
            if (isWin10) return "Win10";
        }
        return "Unknown";
    },
    compareVersion:(v1, v2) => {
        v1 = v1.split(".");
        v2 = v2.split(".");
      
        var len = Math.max(v1.length, v2.length);
      
        while (v1.length < len) {
          v1.push("0");
        }
      
        while (v2.length < len) {
          v2.push("0");
        }
      
        for (var i = 0; i < len; i++) {
          var num1 = parseInt(v1[i]);
          var num2 = parseInt(v2[i]);
      
          if (num1 > num2) {
            return 1;
          } else if (num1 < num2) {
            return -1;
          }
        }
        return 0;
    },
    replaceUrlParameter:(url) => {
        const params = {
          __h5host__: Util.getOrigin("", {noProtocol:true}),
          __pathLang__: Locale.intl.locale,
          __lang__: Locale.getLangCode() || "en",
          __currency__: "usd"
        };
        const reg = new RegExp(`(${Object.keys(params).join('|')})`, 'g');
        return url.replace(reg, attr => params[attr]);
    },
    generateNonceStr:(length, type)=>{
        let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        type === "num" && (chars = "0123456789");
        const maxPos = chars.length;
        let noceStr = "";
        for (let i = 0; i < (length || 32); i++) {
            noceStr += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return noceStr;
    }
}
export default Util;
